import { baseApi as api } from "../base_api";
import { Address } from "./types";

const injectedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAddress: build.query<GetAddressApiResponse, GetAddressApiArg>({
      query: (queryArg) => ({
        url: `/api/account/address`,
        params: {
          searchString: queryArg.searchString,
        },
      }),
    }),
    getAddressDetails: build.query<
      GetAddressDetailsApiResponse,
      GetAddressDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/account/addressDetails`,
        params: {
          placeId: queryArg.placeId,
        },
      }),
    }),
    postVerifyAddress: build.mutation<
      PostVerifyAddressApiResponse,
      PostVerifyAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/api/account/training/test/verifyAddress`,
        method: "POST",
        body: queryArg.verifyAddressPayload,
      }),
    }),
  }),
  overrideExisting: false,
});

export type GetAddressApiResponse =
  /** status 200 OK */ PlacesAutocompleteResponse;
export interface GetAddressApiArg {
  searchString: string;
}
export type GetAddressDetailsApiResponse =
  /** status 200 OK */ PlaceAddressResponse;
export interface GetAddressDetailsApiArg {
  placeId: string;
}
export type PostVerifyAddressApiResponse = /** status 200 OK */ Address[];
export interface PostVerifyAddressApiArg {
  verifyAddressPayload: VerifyAddressPayload;
}
export interface VerifyAddressPayload {
  addressLine1: string;
  addressLine2?: string;
  addressLine3?: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}
export interface PredictionText {
  text?: string;
}
export interface PlacePrediction {
  placeId?: string;
  text?: PredictionText;
}
export interface Suggestion {
  placePrediction?: PlacePrediction;
}
export interface PlacesError {
  code: number;
  message?: string;
  status?: string;
}
export interface PlacesAutocompleteResponse {
  suggestions?: Suggestion[];
  error?: PlacesError;
}
export interface AddressComponent {
  longText?: string;
  shortText?: string;
  types?: string[];
}
export interface PlaceAddressResponse {
  place?: AddressComponent[];
}

export const {
  useGetAddressQuery,
  useGetAddressDetailsQuery,
  usePostVerifyAddressMutation,
} = injectedApi;
